import base from "@/store/utils/api-route/base";

const snapMesinAPI = {
    list: `${base.meta}list_snap_mesin`,
    listMesinUrut: `${base.meta}list_snap_mesin_by_jenis`,
    connectionReport: `${base.meta}report_connection_mesin`,
    lastestVersionMesin: `${base.meta}latest_version_snap_mesin`,
    layananByAid: `${base.meta}transaksi_detail_by_aid`,
    detailMesin: `${base.meta}detail_snap_mesin`,
    liatTagMesin: `${base.meta}list_tag_mesin`,

    hapusMesin: `${base.snapMesin}hapus_snap_mesin`,
    updateMesin: `${base.snapMesin}update_snap_mesin`,
    cekIdMesin: `${base.snapMesin}cek_id_mesin`,
    addMesin: `${base.snapMesin}create_snap_mesin`,
    updateMesinSorting: `${base.snapMesin}sorting_snap_mesin`,


    turnOnMesinTimer: `${base.snapMesin}turn_on_mesin_timer`,
    turnOnMesin: `${base.snapMesin}turn_on_mesin`,
    turnOffMesin: `${base.snapMesin}turn_off_mesin`,

}

export default snapMesinAPI